
























helpers = require('../../helpers.coffee')

view_model =
  props:
    contact:
      default: null

    id:
      default: 'manual-task-form-modal'

  components:
    contactPicker: require('./contact_picker')
    taskForm: require('./form')
    confirmDestroy: require('./confirm_destroy')
    dailyEvents: require('./daily_events')

  data: ->
    removing: false
    task: new Task
    selected_contact: null
    show_stage_selection: false

  watch:
    task:
      handler: (value) ->
        @resetMeetingTask() unless @task.isMeetingTask()
      deep: true

  computed:
    show_calendar: ->
      @selected_contact && Session.current_user.isNylas()

  methods:
    resetMeetingTask: ->
      @task.meeting_type_id = null

      if @task.metadata?
        delete @task.metadata['social_link']
        delete @task.metadata['email_invites']

    showTaskModal: (data) ->
      @buildTask(data.task_id)
      @selected_contact = @contact || data.contact
      @removing = false
      @show_stage_selection = true if data.show_stage_selection
      jQuery('#'+@id).modal 'show' if data.id == @id

    hideTaskModal: ->
      jQuery('#'+@id).modal 'hide'

    setSelectedContact: (data) ->
      @selected_contact = data.contact

    taskDestroyed: (data) ->
      @hideTaskModal()
      @$emit('destroyed', { task: @task, event: data.event })

    buildTask: (task_id) ->
      if task_id
        @loadTask(task_id)
      else
        @task = new Task(created_by_type: 'User', type: 'ManualTask', due_on: new Date())

    loadTask: (task_id) ->
      Loader.on()
      new TasksResource().get(@loadTaskSuccess, @unkonwnError, {id: task_id})

    loadTaskSuccess: (data) ->
      Loader.off()
      @task = data.task
      @selected_contact = @task.contact

  beforeDestroy: ->
    EventsBus.$off 'TaskModalForm::Show', @showTaskModal
    EventsBus.$off 'TaskModalForm::Hide', @hideTaskModal

  mounted: ->
    EventsBus.$on 'TaskModalForm::Show', @showTaskModal
    EventsBus.$on 'TaskModalForm::Hide', @hideTaskModal

exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/manual_tasks/modal_form.vue